import AccordionItemHandler from '@/components/forms/new/AccordionItemHandler';
import PartnerAttributeField from './formFields/PartnerAttributeField';

// eslint-disable-next-line no-unused-vars
const PartnerCustomAttributes = ({ darkMode, errors, touched }) => {
    return (
        <AccordionItemHandler key="custom" index={0} label="Custom Attributes">
            {[1, 2, 3].map((num) => (
                <PartnerAttributeField
                    key={`partnerAttribute${num}`}
                    errors={errors}
                    touched={touched}
                    darkMode={darkMode}
                    number={num}
                />
            ))}
        </AccordionItemHandler>
    );
};

export default PartnerCustomAttributes;
